// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DPNYFunSbdbme8hdAhXE {
  height: 100vh;
}

.KTge5vW6os3uGjHnSDj5 {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .mhEocq6ALCCkDaoAlKtd {
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ._9pdxVnXRgEkEFq75Per {
    height: 100%;
    width: 100%;
    object-fit: contain;
    /* border-radius: 20px; */
  }

  .lQItA12sNB_v_Gp3Ln7t {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .XxwC9CxCsFWiK5Ln3r5v {
    width: 66%;
    height: 0;
    padding-bottom: 66%;
    background-color: transparent;
    box-shadow: 0px 0px 0px 9999px rgb(var(--primary-bg));
    border-radius: 15px;
    z-index: 1000;

    position: relative;
    border: 1.5px dashed rgb(var(--placeholder-primary));
  }

  .sSfdgIa0ViqVSqRDNnEO {
    position: absolute;
    top: -15%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 150%;
    text-align: center;

    font-size: 24px;
    font-style: normal;
    font-weight: 510;
    line-height: 32px;
    letter-spacing: -0.264px;
    color: rgb(var(--placeholder-primary));
  }
`, "",{"version":3,"sources":["webpack://./src/pages/qr/qr.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;;IAEZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,6BAA6B;IAC7B,qDAAqD;IACrD,mBAAmB;IACnB,aAAa;;IAEb,kBAAkB;IAClB,oDAAoD;EACtD;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,kBAAkB;;IAElB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,sCAAsC;EACxC","sourcesContent":[".container {\n  height: 100vh;\n}\n\n.qrContent {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .qr {\n    position: relative;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .qrCamera {\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n    /* border-radius: 20px; */\n  }\n\n  .qrBack {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  \n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .qrArea {\n    width: 66%;\n    height: 0;\n    padding-bottom: 66%;\n    background-color: transparent;\n    box-shadow: 0px 0px 0px 9999px rgb(var(--primary-bg));\n    border-radius: 15px;\n    z-index: 1000;\n\n    position: relative;\n    border: 1.5px dashed rgb(var(--placeholder-primary));\n  }\n\n  .scanText {\n    position: absolute;\n    top: -15%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 150%;\n    text-align: center;\n\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 510;\n    line-height: 32px;\n    letter-spacing: -0.264px;\n    color: rgb(var(--placeholder-primary));\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DPNYFunSbdbme8hdAhXE`,
	"qrContent": `KTge5vW6os3uGjHnSDj5`,
	"qr": `mhEocq6ALCCkDaoAlKtd`,
	"qrCamera": `_9pdxVnXRgEkEFq75Per`,
	"qrBack": `lQItA12sNB_v_Gp3Ln7t`,
	"qrArea": `XxwC9CxCsFWiK5Ln3r5v`,
	"scanText": `sSfdgIa0ViqVSqRDNnEO`
};
export default ___CSS_LOADER_EXPORT___;
